<template>

  <div class="lotti-weekly-report-module">

    <div class="lotti-module-title">PDF Ausdruck</div>

    <el-form :model="pdfFormData" label-width="0px" ref="pdfFormData" class="lotti-module-form">

      <el-form-item class="lotti-select-form" v-if="leadView">

        <el-select
            v-model="pdfFormData.therapistId"
            filterable>
          <el-option
              v-for="item in therapistOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

      </el-form-item>

      <el-form-item>

        <div class="lotti-report-date-block">

          <el-date-picker
              :class="getDatePickerClass()"
              v-model="pdfFormData.dateFrom"
              type="week"
              format="yyyy / WW"
              :clearable="true"
              :picker-options="datePickerHelper.getOptions()"
              placeholder="Start">
          </el-date-picker>

          <el-date-picker
              :class="getDatePickerClass()"
              v-model="pdfFormData.dateTo"
              type="week"
              format="yyyy / WW"
              :clearable="true"
              :picker-options="datePickerHelper.getOptions()"
              placeholder="Ende">
          </el-date-picker>

        </div>

      </el-form-item>

      <el-button type="primary" @click="submitReportForm">Erstellen</el-button>

    </el-form>

  </div>

</template>

<script>
import auth from '../../auth.js';
import datePickerHelper from '../../Helpers/DatePickerHelper.js';
import downloadHelper from '../../Helpers/DownloadHelper.js';
import notification from "../../Helpers/NotificationHelper";
import Vue from "../../main";

export default {

  props: {
    leadView: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      auth: auth,
      datePickerHelper: datePickerHelper,

      pdfFormData: {
        dateFrom: '',
        dateTo: '',
        therapistId: null,//always id of therapist is set
      },

      therapistOptions: [],
    }
  },

  methods: {

    getDatePickerClass() {
      return !this.leadView ? 'lotti-report-date-full-width': ''
    },

    submitReportForm() {

      downloadHelper.weeklyLessonsPdf(
          this.pdfFormData.therapistId,
          this.pdfFormData.dateFrom ? datePickerHelper.formatUTCDateUS(this.pdfFormData.dateFrom) : null,
          this.pdfFormData.dateTo ? datePickerHelper.formatUTCDateUS(this.pdfFormData.dateTo) : null,
          // this.pdfFormData.dateFrom ? this.pdfFormData.dateFrom : null,
          // this.pdfFormData.dateTo ? this.pdfFormData.dateTo : null,
          () => {
            notification.showSuccess(this, 'PDF wurde erfolgreich erstellt');
          },
          () => {
            notification.showError(this, 'Fehler beim Erstellen des PDF');
          }
      )
    },

    getAllTherapists() {
      Vue.http.get(
          'api/v1/therapist/get-all'
      ).then(response => {
        this.therapistOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },
  },

  beforeMount() {

    //get all therapists of service if user is lead_therapist, else only user itself
    if(this.leadView) {
      this.getAllTherapists();
    }
  },

  mounted() {
    //if user is set, set own id as therapistId
    if (this.auth.user.profile.id) {
      this.pdfFormData.therapistId = this.auth.user.profile.id
    }
  }
}

</script>